import { AsyncPipe, NgClass } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { getAuthenticatedStatus } from '@app/reducers/auth/auth-service.selectors';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { AppState } from '@reducers/interfaces';
import { mgcIconFlaskRegular } from '@sb/mgc-icons/mgcIcon-flask_regular.icon';
import { featureFlag, FeatureFlagPipe } from '@sb/shared/feature';
import { SbDialogService } from '@sb/ui/dialog';
import { DividerDirective } from '@sb/ui/divider';
import { IconComponent, IconRegistry } from '@sb/ui/icon';
import { PlanType } from '@shiftbase-com/ts-shared/models';
import { take } from 'rxjs';

import { SubscriptionPlanDirective } from '../../../../../../src/app/shared/subscription-plan/subscription-plan.directive';
import { EmployeeModel } from '../../../../reducers/orm/employee/employee.model';
import { LabsDialogComponent } from '../../../labs-dialog/labs-dialog.component';
import { PermissionDirective } from '../../permission.directive';
import { RequestsBadgeService } from '../../sidebar/requests/requests-badge.service';
import { SBHeaderService } from './../sb-header.service';
import { SBProfileClockInItemComponent } from './items/sb-profile-clock-in-item';
import { SBProfileClockOutItemComponent } from './items/sb-profile-clock-out-item';
import { SBProfileClockSwitchItemComponent } from './items/sb-profile-clock-switch-item';
import { SBProfileItemComponent } from './items/sb-profile-item';

@Component({
  selector: 'sb-profile-dropdown',
  imports: [
    NgClass,
    TranslatePipe,
    SBProfileItemComponent,
    PermissionDirective,
    SubscriptionPlanDirective,
    RouterModule,
    SBProfileClockInItemComponent,
    SBProfileClockOutItemComponent,
    SBProfileClockSwitchItemComponent,
    AsyncPipe,
    FeatureFlagPipe,
    IconComponent,
    DividerDirective,
  ],
  templateUrl: 'sb-profile-dropdown.html',
})
export class SBProfileDropdownComponent {
  private store = inject<Store<AppState>>(Store);
  headerService = inject(SBHeaderService);

  @Input()
  open = false;
  @Input()
  employee: EmployeeModel;
  @Input()
  size: number;
  @Input()
  notificationCount: number;

  planType = PlanType;
  Features = featureFlag;

  #requestsBadge = inject(RequestsBadgeService);

  supervisorOpenRequests = this.#requestsBadge.supervisorCount;
  myOpenRequests = this.#requestsBadge.myCount;

  isSoftLogin: boolean;
  // TODO: This AccountStatus values should be documented and typed somewhere else
  private softLoginStatuses = ['paused', 'expired', 'paymentRequired'];
  // Other possible values are: 'ok' and 'test'

  private dialogService = inject(SbDialogService);
  constructor() {
    inject(IconRegistry).registerIcons([mgcIconFlaskRegular]);

    void this.store
      .select(getAuthenticatedStatus)
      .pipe(take(1))
      .subscribe((status) => (this.isSoftLogin = this.softLoginStatuses.includes(status)));
  }

  openLabsDialog() {
    this.dialogService.open(LabsDialogComponent, {});
  }
}
